@if (statResources.length > 0) {
  <div class="row row-gutters">
    @for (resource of statResources; track resource) {
      <!-- when we have all 4 cards then use the following -->
      <!-- NOTE: this requires moving this component outside of the parent column -->
      <!-- <div class="col col-xs-12 col-sm-6 col-md-4 col-lg-3"> -->
      <!-- for now lets just have 2 cards go full width when we can -->
      <div class="col col-xs-12 col-sm-6">
        <mat-card>
          <mat-card-content>
            <glxy-statistic>
              <div class="stats-title">
                <glxy-statistic-title>{{ resource.title | translate }}</glxy-statistic-title>
                <mat-icon [glxyTooltip]="resource.tooltip">info_outline</mat-icon>
              </div>
              @if (resource.resource.error()) {
                <glxy-statistic-value>N/A</glxy-statistic-value>
                <glxy-statistic-title class="stats-subtitle">
                  {{ 'HOME_PAGE.LEAD_METRICS.ERROR_LOADING_METRIC' | translate }}
                </glxy-statistic-title>
              } @else if (resource.resource.isLoading()) {
                <glxy-statistic-value><glxy-loading-spinner [inline]="true" /></glxy-statistic-value>
                <glxy-statistic-title class="stats-subtitle">
                  {{ 'HOME_PAGE.LEAD_METRICS.LOADING_METRIC' | translate }}
                </glxy-statistic-title>
              } @else if (resource.resource.hasValue()) {
                @let stat = resource.resource.value();
                <glxy-statistic-value>{{ stat.value }}</glxy-statistic-value>
                <glxy-statistic-title class="stats-subtitle">
                  {{ stat.subtitle | translate: { count: stat.delta } }}
                </glxy-statistic-title>
              }
            </glxy-statistic>
          </mat-card-content>
        </mat-card>
      </div>
    }
  </div>
}
